module.exports = __webpack_public_path__ + "351650cfd445c1749bdec91f9c5ada03.svg";